import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { SyncProvider } from './context/SyncContext'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SyncProvider>
      <App />
    </SyncProvider>
  </StrictMode>,
)

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    // Resolve against the document URL so base './' works for Electron & preview
    const swUrl = new URL('sw.js', document.baseURI || window.location.href).href
    navigator.serviceWorker.register(swUrl).catch(() => {
      /* file:// / offline — ignore */
    })
  })
}
